import type { Tenant } from '../services/superadmin'
import { TenantWindow } from './SuperadminPage'
import './SuperadminPage.css'
import './SalePage.css'
import { BalanceAfter } from '../components/pos/BalanceAfter'
import { formatTRY } from '../utils/money'
import { FinancePanel } from '../components/superadmin/FinancePanel'

/** Yalnız yerelde: sistem panelindeki işletme penceresinin önizlemesi. */
const demoTenant: Tenant = {
  id: 'orhanli',
  name: 'orhanli',
  display_name: 'Orhanlı Kebap',
  currency: 'TRY',
  timezone: 'Europe/Istanbul',
  student_discount_percent: 0,
  type: 'restaurant',
  features: { cari: true, qrsiparis: true },
  created_at: '2026-10-02T09:00:00Z',
  trial_ends_at: new Date(Date.now() + 6 * 86_400_000).toISOString(),
  contact_phone: '+905321234567',
  deletion_requested_at: null,
  plan: 'plus',
  plan_period: 'aylik',
}

export function TenantWindowDemo() {
  return (
    <div className="superadmin">
      <TenantWindow tenant={demoTenant} onClose={() => {}} onSaved={() => {}} onView={() => {}} />
    </div>
  )
}

/** Yalnız yerelde: cari bakiye önce/sonra kutusu, Borca Yaz penceresinde. */
export function BalanceDemo() {
  const card = (name: string, total: number, before: number) => (
    <div className="dlg__card dlg__card--ask" style={{ position: 'static' }}>
      <h2>Borca Yaz</h2>
      <div className="tablepick__sum">
        <span className="tablepick__sum-text">
          <span>Borca yazılacak</span>
          <small>{name}</small>
        </span>
        <strong>{formatTRY(total)}</strong>
      </div>
      <BalanceAfter before={before} after={before + total} />
      <label className="dlgfield">
        <span>Açıklama (isteğe bağlı)</span>
        <input />
      </label>
      <div className="dlg__buttons dlg__buttons--even">
        <button type="button" className="btn btn--ghost">Geri</button>
        <button type="button" className="btn btn--primary">Borca yaz</button>
      </div>
    </div>
  )
  return (
    <div style={{ display: 'flex', gap: 24, padding: 24, flexWrap: 'wrap', alignItems: 'flex-start' }}>
      {card('Ahmet Usta', 30000, -50000)}
      {card('Melih Bey', 80000, -50000)}
    </div>
  )
}

/** Yalnız yerelde: Gelir-Gider sekmesi (veriyi ekran görüntüsü betiği veriyor). */
export function FinanceDemo() {
  return (
    <div className="superadmin">
      <FinancePanel />
    </div>
  )
}
